import { useCallback, useContext, useEffect, useRef } from 'react';

import { ButtonLearnMore, ContentAction, ContentPromo, ContentSubTitle, ContentText, ContentTitle, Icon, Wrapper } from './AffirmBanner.styled';

import ScrollerModule from 'components/Scroller/ScrollerModule';
import { DEFAULT } from 'components/Scroller/constants';
import { animateUpdate } from '../SearchCard/animations';

import AffirmLogo from 'components/svg/AffirmLogo';
import { AnalyticsContext } from 'contexts/AnalyticsContext';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { useConfig } from 'hooks';

import { TRACKING_ACTION, TRACKING_INTERACTION } from 'contexts/AnalyticsContext/Constants';
import { useFeatureFlags } from '../../hooks/LaunchDarkly/useFeatureFlags';

function AffirmBanner() {
	const { endpoints, publicKeys } = useConfig();
	const { globalization } = useContext(CruiseSearchContext);
	const { enableAffirm } = useFeatureFlags();
	const { generalDictionary } = globalization?.dictionaries || {};
	const { actionLearnMore, labelBuyNowPayOverTime, labelMakeMonthlyPayments } = generalDictionary;
	const { utagAffirmBanner } = useContext(AnalyticsContext);

	const targetNode = document.querySelector('body');
	const config = { childList: true };

	const wrapperRef = useRef();
	const animatedIn = useRef(false);
	const animatedOut = useRef(false);
	const refs = useRef({
		wrapperRef,
		animatedIn,
		animatedOut,
	});

	const onUpdate = useCallback((params) => {
		animateUpdate({ ...params, refs });
	}, []);

	const sendAffirmEvent = (interaction) => {
		utagAffirmBanner(TRACKING_ACTION.INTERACTIONS, interaction);
	};

	const callback = (mutations) => {
		mutations.forEach((mutationRecord) => {
			if (mutationRecord.type === 'childList') {
				if (mutationRecord.addedNodes.length > 0) {
					mutationRecord.addedNodes.forEach((node) => {
						if (node.className === 'affirm-sandbox-container') sendAffirmEvent(TRACKING_INTERACTION.AFFIRM_BANNER.OPENED);
					});
				}

				if (mutationRecord.removedNodes.length > 0) {
					mutationRecord.removedNodes.forEach((node) => {
						if (node.className === 'affirm-sandbox-container') {
							sendAffirmEvent(TRACKING_INTERACTION.AFFIRM_BANNER.CLOSED);
							observer.disconnect();
						}
					});
				}
			}
		});
	};
	const observer = new MutationObserver(callback);

	useEffect(() => {
		var affirm_config = {
			public_api_key: publicKeys.affirmPublicId,
			script: endpoints.affirmApi,
		};

		(function (m, g, n, d, a, e, h, c) {
			var b = m[n] || {},
				k = document.createElement(e),
				p = document.getElementsByTagName(e)[0],
				l = function (a, b, c) {
					return function () {
						a[b]._.push([c, arguments]);
					};
				};
			b[d] = l(b, d, 'set');
			var f = b[d];
			b[a] = {};
			b[a]._ = [];
			f._ = [];
			b._ = [];
			b[a][h] = l(b, a, h);
			b[c] = function () {
				b._.push([h, arguments]);
			};
			a = 0;
			for (c = 'set add save post open empty reset on off trigger ready setProduct'.split(' '); a < c.length; a++) f[c[a]] = l(b, d, c[a]);
			a = 0;
			for (c = ['get', 'token', 'url', 'items']; a < c.length; a++) f[c[a]] = function () {};
			k.async = !0;
			k.src = g[e];
			p.parentNode.insertBefore(k, p);
			delete g[e];
			f(g);
			m[n] = b;
		})(window, affirm_config, 'affirm', 'checkout', 'ui', 'script', 'ready', 'jsReady');
	}, []);

	const handleClick = () => {
		observer.observe(targetNode, config);
	};

	return (
		!!enableAffirm && (
			<ScrollerModule id={labelBuyNowPayOverTime} scrollerId={DEFAULT} onUpdate={onUpdate}>
				<Wrapper id="affirm-banner" ref={wrapperRef}>
					<Icon>
						<AffirmLogo />
					</Icon>
					<ContentPromo>
						<ContentText>
							<ContentTitle>{labelBuyNowPayOverTime}</ContentTitle>
							<ContentSubTitle>{labelMakeMonthlyPayments}</ContentSubTitle>
						</ContentText>
						<ContentAction>
							<ButtonLearnMore
								variant="calendarSemiBold"
								component="button"
								className="affirm-site-modal"
								data-page-type="homepage"
								onClick={handleClick}
							>
								{actionLearnMore}
							</ButtonLearnMore>
						</ContentAction>
					</ContentPromo>
				</Wrapper>
			</ScrollerModule>
		)
	);
}

export default AffirmBanner;
